module.exports = __webpack_public_path__ + "img/s7bLogo3.5ab16bda.svg";